import { useDealItemPicker } from '../DealItemPicker';
import { React } from 'libs/react';
import './DealItemPickerProduct.scss';
/**
 * @component DealItemPickerProduct
 * @since 1.0.0
 * @hidden
 */
export function DealItemPickerProduct(props) {
    const { style } = props;
    const { item } = useDealItemPicker();
    if (item == null) {
        return null;
    }
    return (React.createElement("div", { className: "deal-item-picker-tool-bar-item" },
        React.createElement("div", { className: "deal-item-picker-tool-bar-item-label" }, t('Product')),
        React.createElement("div", { className: "deal-item-picker-tool-bar-item-value" }, item.title)));
}
